import { Directive, ElementRef, HostListener, EventEmitter, Output } from '@angular/core';
import { VldGroupDirective } from 'directives/vld-group/vld-group';
import { VldGroupState } from 'directives/vld-group/vld-group-interface';

@Directive({
    selector: '[vld-button]',
    standalone: false
})
export class VldButtonDirective {
  group: VldGroupDirective;

  originalVisibility: string;
  shown: boolean = true; // as in "our internal state"
  @Output() vldClick: EventEmitter<any> = new EventEmitter(); /** Only sends clicked event if there are no errors. */

  constructor(public element: ElementRef) { }

  ngOnInit() {
    this.originalVisibility = this.element.nativeElement.style.visibility;
    // the template is assumed made visible state - otherwise we wouldn't know _which_ state to use for visible
    console.assert(this.originalVisibility != 'hidden' && this.originalVisibility != 'collapse');
  }

  enableButton(enable: boolean) {
    this.element.nativeElement.disabled = !enable;
  }

  showButton(show: boolean) {
    if (!show != !this.shown) {
      this.element.nativeElement.style.visibility = show ? this.originalVisibility : 'hidden';
      this.shown = !!show;
    }
  }

  @HostListener('click', ['$event'])
  clickEvent(event:Event) {
    this.group.onNextClicked(event);
    if (this.group.state >= VldGroupState.Ready) {
      this.vldClick.emit();
    }
  }
}
